// import { useEffect, useState } from 'react';
// import { 
//   getCookiePreferences, 
//   saveCookiePreferences, 
//   hasCookiePreferences, 
//   DEFAULT_PREFERENCES 
// } from 'Config/CookiesData';
// import { applyCookiePreferences } from 'Utils/CookieManager';

// export interface CookiePreferences {
//   essential: boolean;
//   performance: boolean;
//   marketing: boolean;
// }

// export const useCookieConsent = () => {
//   const [preferences, setPreferences] = useState<CookiePreferences>(() => {
//     const saved = getCookiePreferences();
//     return saved || DEFAULT_PREFERENCES;
//   });
  
//   const [showBanner, setShowBanner] = useState<boolean>(false);
//   const [showDetailedDialog, setShowDetailedDialog] = useState<boolean>(false);
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     const hasPrefs = hasCookiePreferences();
//     if (!hasPrefs) {
//       setShowBanner(true);
//       applyCookiePreferences(DEFAULT_PREFERENCES);
//     } else {
//       setShowBanner(false);
//       const saved = getCookiePreferences();
//       if (saved) {
//         setPreferences(saved);
//         applyCookiePreferences(saved);
//       }
//     }
//     setIsLoading(false);
//   }, []);

//   useEffect(() => {
//     if (!isLoading) {
//       applyCookiePreferences(preferences);
//     }
//   }, [preferences, isLoading]);

//   const notifyPreferenceChange = (prefs: CookiePreferences) => {
//     applyCookiePreferences(prefs);
//     const event = new CustomEvent('cookiePreferencesUpdated', { detail: prefs });
//     window.dispatchEvent(event);
//   };

//   const acceptAll = () => {
//     const newPreferences: CookiePreferences = {
//       essential: true,
//       performance: true,
//       marketing: true,
//     };
//     setPreferences(newPreferences);
//     saveCookiePreferences(newPreferences);
//     notifyPreferenceChange(newPreferences);
//     setShowBanner(false);
//     setShowDetailedDialog(false);
//   };

//   const rejectAll = () => {
//     const newPreferences: CookiePreferences = {
//       essential: true,
//       performance: false,
//       marketing: false,
//     };
//     setPreferences(newPreferences);
//     saveCookiePreferences(newPreferences);
//     notifyPreferenceChange(newPreferences);
//     setShowBanner(false);
//     setShowDetailedDialog(false);
//   };

//   const savePreferences = (customPreferences?: CookiePreferences) => {
//     const prefsToSave = customPreferences || preferences;
//     setPreferences(prefsToSave);
//     saveCookiePreferences(prefsToSave);
//     notifyPreferenceChange(prefsToSave);
//     setShowBanner(false);
//     setShowDetailedDialog(false);
//   };

//   const openDetailedDialog = () => {
//     setShowDetailedDialog(true);
//   };

//   const closeDetailedDialog = () => {
//     setShowDetailedDialog(false);
//   };

//   return {
//     preferences,
//     showBanner,
//     showDetailedDialog,
//     isLoading,
//     acceptAll,
//     rejectAll,
//     savePreferences,
//     openDetailedDialog,
//     closeDetailedDialog,
//   };
// };

import { useEffect, useState } from 'react';
import { 
  getCookiePreferences, 
  saveCookiePreferences, 
  hasCookiePreferences, 
  DEFAULT_PREFERENCES 
} from 'Config/CookiesData';
import { applyCookiePreferences } from 'Utils/CookieManager';

export interface CookiePreferences {
  essential: boolean;
  performance: boolean;
  marketing: boolean;
}

export const useCookieConsent = () => {
  // Başlangıç değerlerini al
  const [preferences, setPreferences] = useState<CookiePreferences>(() => {
    const saved = getCookiePreferences();
    return saved || DEFAULT_PREFERENCES;
  });
  
  const [showBanner, setShowBanner] = useState<boolean>(false);
  const [showDetailedDialog, setShowDetailedDialog] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);

  // Sayfa yüklendiğinde kontrol et
  useEffect(() => {
    const hasPrefs = hasCookiePreferences();
    if (!hasPrefs) {
      // Tercih yoksa: Banner göster, varsayılanları (Sadece Zorunlu) uygula
      setShowBanner(true);
      applyCookiePreferences(DEFAULT_PREFERENCES);
    } else {
      // Tercih varsa: Banner gizle, kayıtlıyı uygula
      setShowBanner(false);
      const saved = getCookiePreferences();
      if (saved) {
        setPreferences(saved);
        applyCookiePreferences(saved);
      }
    }
    setIsLoading(false);
  }, []);

  // Tercihler değiştiğinde Manager'ı tetikle
  useEffect(() => {
    if (!isLoading) {
      applyCookiePreferences(preferences);
    }
  }, [preferences, isLoading]);

  const notifyPreferenceChange = (prefs: CookiePreferences) => {
    applyCookiePreferences(prefs);
    const event = new CustomEvent('cookiePreferencesUpdated', { detail: prefs });
    window.dispatchEvent(event);
  };

  const acceptAll = () => {
    const newPreferences: CookiePreferences = {
      essential: true,
      performance: true,
      marketing: true,
    };
    setPreferences(newPreferences);
    saveCookiePreferences(newPreferences);
    notifyPreferenceChange(newPreferences);
    setShowBanner(false);
    setShowDetailedDialog(false);
  };

  const rejectAll = () => {
    const newPreferences: CookiePreferences = {
      essential: true, // Zorunlu yine true kalır
      performance: false,
      marketing: false,
    };
    setPreferences(newPreferences);
    saveCookiePreferences(newPreferences);
    notifyPreferenceChange(newPreferences);
    setShowBanner(false);
    setShowDetailedDialog(false);
  };

  const savePreferences = (customPreferences?: CookiePreferences) => {
    const prefsToSave = customPreferences || preferences;
    setPreferences(prefsToSave);
    saveCookiePreferences(prefsToSave);
    notifyPreferenceChange(prefsToSave);
    setShowBanner(false);
    setShowDetailedDialog(false);
  };

  const openDetailedDialog = () => setShowDetailedDialog(true);
  const closeDetailedDialog = () => setShowDetailedDialog(false);

  return {
    preferences,
    showBanner,
    showDetailedDialog,
    isLoading,
    acceptAll,
    rejectAll,
    savePreferences,
    openDetailedDialog,
    closeDetailedDialog,
  };
};